export const APP_URL = "https://app.farmapp.in";
